/*=========================================================================================
  File Name: moduleAttack.js
  Description: Attack Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAttackState.js'
import mutations from './moduleAttackMutations.js'
import actions from './moduleAttackActions.js'
import getters from './moduleAttackGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}